module.exports = __webpack_public_path__ + "9c303bc4645d3d9a6bb09077607fbfb2.png";